const loadingBar = {
  start() {
    const duration = 350;
    $('.loading-bar').css('width', 0).css('left', 0).css('right', 'auto');

    $('.loading-bar').fadeIn().animate(
      {
        width: '100%',
      },
      duration,
      'easeOutQuad'
    );
  },
  end() {
    $('.loading-bar').stop().clearQueue().fadeOut();
  },
};

export default loadingBar;
